import React, { useContext, useState } from "react";

export const GlobalContext = React.createContext(null);

// eslint-disable-next-line react/display-name
const GlobalProvider = ({ children }) => {
  const [favorites, setFavorites] = useState(
    typeof window !== "undefined"
      ? localStorage.getItem("Favourites")
        ? JSON.parse(localStorage.getItem("Favourites"))
        : []
      : []
  );
  const [mobileBar, setMobileBar] = useState(false);
  const [bgShadow, setBgShadow] = useState(false);
  const [zIndex, setZIndex] = useState(false);

  const context = {
    favorites,
    setFavorites,
    setMobileBar,
    mobileBar,
    bgShadow,
    setBgShadow,
    zIndex,
    setZIndex,
  };

  return (
    <GlobalContext.Provider value={context}>{children}</GlobalContext.Provider>
  );
};

export default GlobalProvider;

export function useGlobalContext() {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error(
      "useStoreContext bir StoreContextProvider içinde kullanılmalıdır"
    );
  }
  return context;
}
